import styled from "styled-components";
import { FaRegUser } from "react-icons/fa6";
import { sizes } from "../../01_config/Sizes";
import { Link } from "react-router-dom";

const UserIcon = styled(FaRegUser)`
    position: relative;
    top: 3px;
    font-size: 1.6rem;
    border: 3.5px solid black;
    border-radius: 5px;
    margin-left: ${sizes.margins_desk};
    cursor: pointer;
`

const UserWrapper = styled.div`
    position: absolute;
    width: 150px;
    background-color: lightgray;
    right: ${sizes.margins_desk};
    top: ${sizes.headerheight};
    @media(max-width: 800px) {
        right: 0;
        top: ${sizes.headerhight_mobile}
    }
`
const UserItem = styled(Link)`
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    padding-left: 5px;
    border-bottom: gray solid 1px;
    cursor: pointer;
    user-select: none;
    text-decoration: none;
    color: black;
    &:hover {
        background-color: grey;
    };
    @media(max-width: 800px) {
        justify-content: center;
    }

`

const YouAreLogged = styled.div`
    position: absolute;
    bottom: 0;
    white-space: normal;
    right: ${sizes.margins_desk};
    color: red;
    color: ${({logged}) => logged=="logged out" ? "red" : "green"};
    font-weight: ${({guestMessage}) => guestMessage ? "bold" : ""};
    user-select: none;
    @media(max-width: 800px) {
        text-align: right;
        top: 50px;
        max-width: 400px;
        right: ${sizes.marginmobile};
    }
`

const FullScreenWrapper = styled.div`
    top: 0;
    left: 0;
    position: absolute;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,0.1);
    display: ${({userMenu}) => userMenu ? "block" : "none" };
`

export { UserIcon, UserWrapper, UserItem, YouAreLogged, FullScreenWrapper }